import type { SpaceAuditEntry, SpaceDetail } from '@/types/spaces';
import { participantName } from './settlement';

export const AUDIT_PAGE_SIZE = 10;

// The roster names current members (and disambiguates duplicates); the audit keeps the saved name of someone
// who left, so a raw user id only shows once the account itself is gone.
export function auditActorName(space: SpaceDetail, entry: Pick<SpaceAuditEntry, 'actorUserId' | 'actorName'>): string {
  const current = space.members.some((member) => member.userId === entry.actorUserId);
  return (!current && entry.actorName?.trim()) || participantName(space, entry.actorUserId);
}

export function auditDate(createdAt: string): string {
  return new Date(createdAt).toLocaleString('pt-BR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}
